import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Translate} from 'react-redux-i18n';
import {COUNTRY} from 'front-onceforall-core/dist/utils/country';
import * as snackbarsActions from '../../../actions/snackbars';
import HeaderView from './HeaderView';
import SubcontractorAddPanel from './subcontractorAddPanel';
import AccessCodeModal from './accessCodeModal';
import {useSubcontractorsStore} from '../SubcontractorsStore';
import documentService from '../../../services/document/DocumentService';
import {captureError} from '../../../utils/log';
import {getFirstDossierCountry, setFirstDossierCountry} from '../../../utils/document';
import {recordGAEvent} from '../../../utils/analytics';

const countries = [
  COUNTRY.FRANCE,
  COUNTRY.GERMANY,
  COUNTRY.ITALY
];

function HeaderContainer() {
  const [organisation, currentLocale, user] = useSelector(state => [
    state.organisation,
    state.i18n.locale,
    state.user
  ]);
  const globalDispatch = useDispatch();
  const {dispatch} = useSubcontractorsStore();
  const [isAccessCodeModalOpen, setIsAccessCodeModalOpen] = React.useState(false);
  const [isAddSubcontractorPanelOpen, setIsAddSubcontractorPanelOpen] = React.useState(false);
  const [reinvitedOrganisation, setReinvitedOrganisation] = React.useState(null);

  function handleDownloadExport() {
    recordGAEvent('BUYER_DOSSIER', 'Export all suppliers folder for my siret');
    const data = {
      userId: user.id,
      organisationId: organisation.organisationId,
      locale: currentLocale
    };

    documentService.createDocumentExport(data)
      .then(() => globalDispatch(snackbarsActions.addSuccess(<Translate value="message.exportRequestSuccess"/>)))
      .catch(error => {
        captureError('documentService.createDocumentExport', error);
        globalDispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
      });
  }

  function handleDossierCountryChange(event) {
    const country = event.target.value;
    dispatch({
      type: 'UPDATE_DOSSIER_STATE_COUNTRY',
      country
    });
    setFirstDossierCountry(country);
  }

  function reinviteSubcontractor({detail}) {
    setIsAddSubcontractorPanelOpen(true);
    setReinvitedOrganisation(detail);
  }

  function handleCloseAddPanel() {
    setIsAddSubcontractorPanelOpen(false);
    setReinvitedOrganisation(null);
    dispatch({type: 'FETCH_DATA'});
  }

  React.useEffect(() => {
    window.addEventListener('reinviteSubcontractor', reinviteSubcontractor);
    return () => {
      window.removeEventListener('reinviteSubcontractor', reinviteSubcontractor);
    };
  }, []);

  React.useEffect(() => {
    const value = getFirstDossierCountry(countries, organisation.country);
    handleDossierCountryChange({target: {value}});
  }, [organisation.country]);

  return (
    <>
      <HeaderView
        countries={countries}
        onOpenAccessCodeModal={() => setIsAccessCodeModalOpen(true)}
        onOpenAddSubcontractorPanel={() => setIsAddSubcontractorPanelOpen(true)}
        onDownloadExport={handleDownloadExport}
        onDossierCountryChange={handleDossierCountryChange}
      />
      <SubcontractorAddPanel
        isOpen={isAddSubcontractorPanelOpen}
        onClose={handleCloseAddPanel}
        reinvitedOrganisation={reinvitedOrganisation}
      />
      {isAccessCodeModalOpen &&
        <AccessCodeModal
          onClose={() => setIsAccessCodeModalOpen(false)}
        />
      }
    </>
  );
}

export default HeaderContainer;
